import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { stagesInfo } from '@/composables/stagesInfo'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/index.html',
    name: 'home_index',
    component: HomeView
  },
  {
    path: '/stage-1/',
    name: 'stage-1',
    component: () => import(/* webpackChunkName: "stageView" */ '../views/StageView.vue'),
    props: {
      stageInfo: stagesInfo[0],
    },
  },
  {
    path: '/stage-2/',
    name: 'stage-2',
    component: () => import(/* webpackChunkName: "stageView" */ '../views/StageView.vue'),
    props: {
      stageInfo: stagesInfo[1],
    },
  },
  {
    path: '/stage-3/',
    name: 'stage-3',
    component: () => import(/* webpackChunkName: "stageView" */ '../views/StageView.vue'),
    props: {
      stageInfo: stagesInfo[2],
    },
  },
  {
    path: '/stage-4/',
    name: 'stage-4',
    component: () => import(/* webpackChunkName: "stageView" */ '../views/StageView.vue'),
    props: {
      stageInfo: stagesInfo[3],
    },
  },
  {
    path: '/picture-book/',
    name: 'picture-book',
    component: () => import(/* webpackChunkName: "pictureBookView" */ '../views/PictureBookView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
